export function initializeCopyResources() {
    this._udimMaterials = new Map();

    if (this.mesh) {
        this.mesh.traverse(child => {
            if (!child.isMesh) return;
            if (!child.material) return;
        });
    }
}

export function throttledUpdate() {
    const now = performance.now();
    this.render();
    if (now - this.lastUpdateTime >= this.updateThrottleDelay && !this.updatePending) {
        this.updatePending = true; this.lastUpdateTime = now;
        requestAnimationFrame(() => { this.updateProjectiveDecalPreview(); this.updatePending = false; });
    }
}

export function compositeTexture(channelIndex) {
    const ch = this.uvChannels[channelIndex];
    if (!ch) return;

    const ctx = ch.compositeContext;
    ctx.clearRect(0, 0, ch.compositeCanvas.width, ch.compositeCanvas.height);
    ctx.drawImage(ch.baseCanvas, 0, 0, ch.compositeCanvas.width, ch.compositeCanvas.height);
    ctx.globalCompositeOperation = 'source-over';
    ctx.drawImage(ch.decalCanvas, 0, 0, ch.compositeCanvas.width, ch.compositeCanvas.height);

    if (ch.texture && ch.texture.image !== ch.compositeCanvas) {
        ch.texture.image = ch.compositeCanvas;
    }
    ch.texture.needsUpdate = true;

    this.updateSubmeshTextures(ch.udimTile);

    if (this.projective3D && this.projective3D.updateCompositeTextures && this.projectionMode !== 'brush') {
        this.projective3D.updateCompositeTextures();
    }

    this.render();
}

export function updateSubmeshTextures(udimTile) {
    if (!this.mesh) return;

    if (!this._udimMaterials) this._udimMaterials = new Map();
    if (!this._udimMaterials.has(udimTile)) {
        const bucket = [];
        this.mesh.traverse(child => {
            if (!child.isMesh) return;
            if (!child.material) return;
            bucket.push(child.material);
        });
        this._udimMaterials.set(udimTile, bucket);
    }

    const mats = this._udimMaterials.get(udimTile) || [];
    const channel = this.uvChannels.find(ch => ch.udimTile === udimTile);
    if (!channel) return;

    for (const mat of mats) {
        if (mat.map !== channel.texture) {
            mat.map = channel.texture;
        }
    }
}

export function animate() {
    requestAnimationFrame(() => this.animate());
    if (this.controls) this.controls.update();
    this.render();
}

export function render() {
    if (!this.renderer || !this.scene || !this.camera) return;
    this.renderer.render(this.scene, this.camera);
}
